var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prize-user',{attrs:{"avatar":_vm.source.avatar,"username":_vm.source.username,"level":_vm.source.level,"points":_vm.source.points,"rank":_vm.source.rank}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1617966f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/sharedcomponents/PrizeUserWrapper.vue
// module id = null
// module chunks = 